import { render, staticRenderFns } from "./NewProductDialog.vue?vue&type=template&id=0586b79a&scoped=true&"
import script from "./NewProductDialog.vue?vue&type=script&lang=ts&"
export * from "./NewProductDialog.vue?vue&type=script&lang=ts&"
import style0 from "./NewProductDialog.vue?vue&type=style&index=0&id=0586b79a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0586b79a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VRow,VTextField,VTextarea})
